import { BCChat, findMessage, IAlertTypes } from '@bimser/components';
import React from 'react';
import { ServiceList } from '../../../services/serviceList';
import { IAssistantMessage, IMessage } from '@bimser/components/dist/BCChat/entities/IMessage';
import IChatWithDocumentProps from '../entities/IChatWithDocumentProps';
import HTTPRequest from '../../../services/HTTPRequest';

const predefinedPrompts: (typeof BCChat.defaultProps)['predefinedPrompts'] = [
	findMessage.get('103599'),
	findMessage.get('103600'),
	findMessage.get('103601')
].map((item: string, index: number) => ({ key: index.toString(), prompt: item, text: item }));

const ChatWithDocument = (props: IChatWithDocumentProps) => {
	const [notifications, setNotifications] = React.useState<
		(typeof BCChat.defaultProps)['notifications']
	>([]);
	const [messages, setMessages] = React.useState<(typeof BCChat.defaultProps)['messages']>([]);
	const [loading, setLoading] = React.useState<boolean>(false);

	const setUserMessage = (prompt: string) => {
		const userMessage: IMessage = {
			content: prompt,
			key: Date.now().toString(),
			role: 'user'
		};

		setMessages(prev => [...prev, userMessage]);
	};

	const setAssistantMessage = (assistantMessage: IAssistantMessage) => {
		setMessages(prev => {
			const streamingMessage = prev.findIndex(message => message.key == assistantMessage.key);
			const newState = [...prev];

			if (streamingMessage > -1) {
				newState[streamingMessage] = assistantMessage;
			} else {
				newState.push(assistantMessage);
			}

			return newState;
		});
	};

	const onPromptSent = (prompt: string) => {
		setLoading(true);
		setUserMessage(prompt);

		const url =
			(window as any).serviceConfig.services.dm.baseURL + '/DocumentManagement/AI/Chat';
		fetch(url, {
			method: 'POST',
			body: JSON.stringify({
				sessionId: props.sessionID,
				prompt
			}),
			headers: {
				...HTTPRequest.defaultHeaders,
				'Content-Type': 'application/json'
			}
		})
			.then(response => {
				const reader = response.body.getReader();
				const decoder = new TextDecoder('utf-8');

				let assistantMessage: IAssistantMessage = {
					content: '',
					key: response.headers.get('Feedback_id'),
					role: 'assistant',
					streaming: true
				};

				const processStream = async () => {
					const { done, value } = await reader.read();

					if (done) {
						assistantMessage.streaming = false;
						setAssistantMessage(assistantMessage);

						setLoading(false);
						return;
					}

					assistantMessage.content += decoder.decode(value, { stream: true });
					setAssistantMessage(assistantMessage);
					processStream();
				};

				processStream();
			})
			.catch(() => {
				setNotifications([
					{
						key: Date.now().toString(),
						type: IAlertTypes.error,
						description: findMessage.get('102106'),
						message: findMessage.get('102639')
					}
				]);
				setLoading(false);
			});
	};

	const onResponseSent = (
		args: Parameters<(typeof BCChat.defaultProps)['onResponseSent']>[0]
	) => {
		const request = {
			sessionId: props.sessionID,
			feedBack: args.type == 'good',
			feedBackDetail: args.feedback,
			feedBackId: args.message.key
		};

		return ServiceList.dm.DocumentManagement.AI.FeedBack.callPromise(request, true);
	};

	return (
		<BCChat
			messages={messages}
			onResponseSent={onResponseSent}
			notifications={notifications}
			loading={loading}
			disabled={loading}
			onPromptSent={onPromptSent}
			predefinedPrompts={predefinedPrompts}
			placeHolder={findMessage.get('103602')}
		/>
	);
};

export default ChatWithDocument;
